import React, { useState, useCallback, useEffect } from 'react';
import { orgTypes } from '../../Constants';
// import Notification from '../Notification';
import useApi from '../../api/useApi';

function CreateOrganization({ handleClose, notification, action, selectedOrg, refreshList }) {
  const user = sessionStorage.getItem('user');
  if (!user) {
    location.href = '/';
  }
  const { userId } = JSON.parse(sessionStorage.user).user;

  const formModel = {
    organizationType: '0',
    organizationName: '',
    website: '',
    email: '',
    spoc: '',
    status: 'Active',
    remarks: '',
    createdBy: userId,
    address: {
      location: '',
      city: '',
      state: '',
      country: '',
      zip: '',
    },
  };

  const [formData, setFormData] = useState(formModel);
  const [{ isLoading, isError, data }, postData] = useApi();
  const [state, getDataForUpdate] = useApi();
  const [state2, updateData] = useApi();

  const handleInputChange = useCallback((e) => setFormData({ ...formData, [e.target.name]: e.target.value }));

  const handleAddressChange = useCallback((e) =>
    setFormData({ ...formData, address: { ...formData.address, [e.target.name]: e.target.value } })
  );

  // useEffect(() => {
  //  console.log(formData);
  // }, [formData]);

  useEffect(() => {
    if (action === 'update') {
      getDataForUpdate(`/organization/${selectedOrg}`, 'GET');
    }
  }, [action]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (action === 'create') postData('/organization', 'POST', formData);
    else updateData(`/organization/${selectedOrg}`, 'PATCH', formData);
  };

  // create response
  useEffect(() => {
    if (!isLoading && !isError && data) {
      setFormData({ ...formModel });
      refreshList();
      notification('success', 'Organization Created Successfully');
      handleClose();
    }

    if (isError) {
      notification('error', 'Unable to Create Organization');
    }
  }, [isLoading, isError, data]);

  // getOrganization for update response
  useEffect(() => {
    if (!state.isLoading && !state.isError && state.data) {
      setFormData({
        ...state.data.organization,
        address: { ...state.data.organization.Address, location: state.data.organization.Address.locality },
      });
    }
    if (state.isError) {
      notification('error', 'Unable to fetch Organization Record');
    }
  }, [state]);

  // update response
  useEffect(() => {
    if (state2.data !== null) {
      refreshList();
      notification('success', 'Organization Updated Successfully');
      handleClose();
    }

    if (state2.isError) {
      notification('error', 'Unable to update organization');
    }
    // console.log("!state.isError",state2.isError)
  }, [state2]);

  return (
    <div
      className="flex justify-center items-center h-full w-full z-20 fixed"
      style={{ background: 'linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5))', overflowY: 'scroll' }}
    >
      <div className={`bg-white w-full md:w-2/4 px-5 pt-4 relative top-${action === 'create' ? 0 : 8} rounded-2xl`}>
        <img
          src="assets/img/Close.svg"
          className="absolute top-3 right-3 h-3 cursor-pointer"
          alt=""
          onClick={handleClose}
        />

        <p className="font-bold text-sm text-textBlue1 border-b p-4">
          {action === 'create' ? 'Create' : 'Edit'} an Organization
        </p>

        <form className="mt-6 mb-2 mx-2 md:mx-10 flex flex-wrap" onSubmit={handleSubmit}>
          <div className="mt-4 w-2.25/5 relative">
            {/* <label htmlFor="company" className="block text-parameter w-1/3 text-sm">
              NAME
            </label>
            <input
              type="text"
              placeholder="Project"
              value={formData.organizationName}
              name="projectName"
              className="inputLabelText px-4 py-2 focus:outline-none"
              onChange={handleInputChange}
            /> */}
            <input
              type="text"
              placeholder="Name"
              value={formData.organizationName}
              name="organizationName"
              className="inputLabelText px-4 py-2 focus:outline-none"
              onChange={handleInputChange}
            />
          </div>
          <div className="w-1/10" />
          <div className="mt-4 w-2.25/5 relative">
            {/* <label htmlFor="address" className="block text-parameter w-1/3 text-sm">
              ADDRESS
            </label> */}
            <input
              type="text"
              placeholder="Address"
              value={formData.address?.location}
              name="location"
              className="inputLabelText px-4 py-2 focus:outline-none"
              onChange={handleAddressChange}
            />
          </div>

          <div className="mt-4 w-2.25/5 relative">
            {/* <label htmlFor="website" className="block text-parameter w-1/3 text-sm">
              WEBSITE
            </label> */}
            <input
              type="text"
              placeholder="Website"
              value={formData.website}
              name="website"
              className="inputLabelText px-4 py-2 focus:outline-none"
              onChange={handleInputChange}
            />
          </div>
          <div className="w-1/10" />
          <div className="mt-4 w-2.25/5 relative">
            {/* <label htmlFor="city" className="block text-parameter w-1/3 text-sm">
              CITY
            </label> */}
            <input
              type="text"
              placeholder="City"
              value={formData.address?.city}
              name="city"
              className="inputLabelText px-4 py-2 focus:outline-none"
              onChange={handleAddressChange}
            />
          </div>

          <div className="mt-4 w-2.25/5 relative">
            {/* <label htmlFor="industry" className="block text-parameter w-1/3 text-sm">
              TYPE
            </label> */}
            {/* <input
       type="text"
       name="organizationType"
       className="rounded-lg bg-white px-4 py-3 focus:outline-none text-textBox border w-1/2 h-10"
       onChange={handleInputChange}
      /> */}
            <div className="inputLabelText px-4 py-2 focus:outline-none">
              <select
                name="organizationType"
                value={formData.organizationType}
                className="border-none w-full focus:outline-none text-sm  text-parameter border"
                onChange={handleInputChange}
              >
                {orgTypes.map((item) => (
                  <option key={item.id} value={item.id} className="fy-4">
                    {item.value}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <div className="w-1/10" />
          <div className="mt-4 w-2.25/5 relative">
            {/* <label htmlFor="state" className="block text-parameter w-1/3 text-sm">
              STATE
            </label> */}
            <input
              placeholder="State"
              type="text"
              name="state"
              value={formData.address?.state}
              className="inputLabelText px-4 py-2 focus:outline-none"
              onChange={handleAddressChange}
            />
          </div>

          <div className="mt-4 w-2.25/5 relative">
            {/* <label htmlFor="email" className="block text-parameter w-1/3 text-sm">
              EMAIL
            </label> */}
            <input
              placeholder="Email"
              type="email"
              name="email"
              value={formData.email}
              className="inputLabelText px-4 py-2 focus:outline-none"
              onChange={handleInputChange}
            />
          </div>
          <div className="w-1/10" />
          <div className="mt-4 w-2.25/5 relative">
            {/* <label htmlFor="country" className="block text-parameter w-1/3 text-sm">
              COUNTRY
            </label> */}
            <input
              placeholder="Country"
              type="text"
              name="country"
              value={formData.address?.country}
              className="inputLabelText px-4 py-2 focus:outline-none"
              onChange={handleAddressChange}
            />
          </div>

          <div className="mt-4 w-2.25/5 relative">
            {/* <label htmlFor="phone" className="block text-parameter w-1/3 text-sm">
              PHONE NUMBER
            </label> */}
            <input
              placeholder="Phone Number"
              type="tel"
              value={formData.contactNo}
              name="contactNo"
              className="inputLabelText px-4 py-2 focus:outline-none"
              onChange={handleInputChange}
            />
          </div>
          <div className="w-1/10" />
          <div className="mt-4 w-2.25/5 relative">
            {/* <label htmlFor="zip" className="block text-parameter w-1/3 text-sm">
              ZIP/PIN
            </label> */}
            <input
              placeholder="Zip/Pin"
              type="text"
              name="zip"
              value={formData.address?.zip}
              className="inputLabelText px-4 py-2 focus:outline-none"
              onChange={handleAddressChange}
            />
          </div>

          <div className="mt-4 w-2.25/5 relative">
            {/* <label htmlFor="notes" className="block text-parameter w-1/3 text-sm">
              NOTES
            </label> */}
            <input
              placeholder="Notes"
              type="text"
              name="remarks"
              value={formData.remarks}
              className="inputLabelText px-4 py-2 focus:outline-none"
              onChange={handleInputChange}
            />
          </div>
          <div className="w-full md:5/12 relative -right-4 md:-right-8 mb-2 mt-4">
            {state2.isLoading || isLoading ? (
              <div className="flex text-xs">
                <img src="assets/img/loader.svg" className="w-16 right-28 mx-auto" alt="" />
              </div>
            ) : (
              <div className="flex text-xs w-full justify-end">
                <button
                  type="submit"
                  onClick={() => handleClose()}
                  className="rounded-3xl border focus:outline-none w-1/4 h-10 mr-3 cursor-pointer  "
                  // style={{ border: '1px solid #16406D' }}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="rounded-3xl focus:outline-none w-1/4 h-10 text-white bg-btnBg cursor-pointer "
                  style={{ border: '1px solid #16406D' }}
                >
                  Save
                </button>
              </div>
            )}
          </div>

          {/* <div className="flex w-full items-center justify-center  mt-6 relative">
            {state2.isLoading || isLoading ? (
              <img src="assets/img/loader.svg" className="w-16 right-36 mx-auto" alt="" />
            ) : (
              <input
                type="submit"
                className="rounded-lg focus:outline-none w-1/4 h-10 text-textBlue1 cursor-pointer "
                style={{ background: '#16406D33', border: '1px solid #16406D' }}
              />
            )}
          </div> */}
        </form>
      </div>
    </div>
  );
}

export default CreateOrganization;
